module.exports = __webpack_public_path__ + "static/media/logo.7bffac71.png";